import { ReactNode } from 'react';
import { LoadingState } from '../common/LoadingState';
import { resolveEntitlementView } from '../../services/entitlement';
import { useEntitlement } from './LicensingProvider';
import { EntitlementRecovery } from './EntitlementRecovery';

export function EntitlementGate({ children }: { children: ReactNode }) {
  const { entitlementState, status, refreshEntitlement } = useEntitlement();
  const view = resolveEntitlementView(entitlementState, false);

  if (view === 'loading') {
    return (
      <main className="flex min-h-screen items-center justify-center bg-[var(--app-canvas)]">
        <LoadingState spinnerSize="xl" className="py-0" />
      </main>
    );
  }

  if (view === 'blocked') {
    return (
      <EntitlementRecovery
        entitlementState={entitlementState}
        status={status}
        onRetry={refreshEntitlement}
      />
    );
  }

  return <>{children}</>;
}
